import { z } from 'zod';
export const Uuid = z.uuid();
export const IsoDateTime = z.iso.datetime({ offset: true });
/** Slugs are used in workspace subdomains (pixelscope.chapsi.app) and channel names. */
export const Slug = z
    .string()
    .min(2)
    .max(48)
    .regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/, 'lowercase letters, numbers and single hyphens');
export const ErrorBody = z.object({
    error: z.object({
        /**
         * `reauth_required`: the action needs a fresh second factor (today: adding a passkey from a session that
         * signed in more than 10 minutes ago). Ask for the emailed code and send it with the retry.
         * `second_factor_required`: this device has not proved its second factor yet (docs/adr/0033); show the
         * second-factor screen. Not a sign-out.
         * `account_pending_deletion`: the person's account is scheduled for deletion (docs/adr/0040); show that
         * screen. Not a sign-out.
         * `workspace_read_only`: the workspace's trial or payment lapsed (docs/adr/0044); reading, searching and
         * exporting still work, but nothing can be posted or created until someone chooses a plan.
         */
        code: z.enum(['bad_request', 'unauthenticated', 'forbidden', 'reauth_required', 'second_factor_required', 'account_pending_deletion', 'workspace_read_only', 'sso_required', 'plan_required', 'two_step_required', 'password_required', 'password_wrong', 'not_found', 'conflict', 'rate_limited', 'internal', 'reason_required', 'not_latest', 'not_approved']),
        message: z.string(),
        issues: z.array(z.object({ path: z.string(), message: z.string() })).optional(),
    }),
});
export const Page = (item) => z.object({ items: z.array(item), nextCursor: z.string().nullable() });
//# sourceMappingURL=common.js.map